module.exports = __webpack_public_path__ + "static/media/8OLA9.c6373b6f.jpg";